import iProductDto from "./i-product-dto";
import IProductsDto from "./i-products-dto";

export class ProductsDto implements IProductsDto {
    public products: iProductDto[] = [];
    public lastPage = false;
    public currentPage = 0;
}
